import React from "react"
import QRCode from "qrcode.react"

export const Etiquette = props => {

  return (
    <div className="displayprint is-vcentered" style={{ display: "flex", flexDirection: "column", paddingLeft: 10, paddingTop: 0, marginTop: 0 }}>
      <div style={{fontSize: 70, fontWeight: "bold"}}>
        {props.casierLibelle}
        <QRCode style={{ marginLeft: "10px", width: 100, height: 100 }} includeMargin={false} value={props.idcarton + ";" + props.idbaguette + ";" + props.fournisseur + ";" + props.nombre + ";" + props.longueur + ";" + props.metrage + ";" + props.famille + ";" + props.couleur + ";" + props.casier + ";" + props.date + ";V1"} />
      </div>
      <div style={{ fontWeight: "bold", fontSize: 44 }}>
        {props.familleLibelle}<span className="separator">|</span>{props.couleurLibelle}
      </div>
      <div style={{ fontWeight: "bold", fontSize: 22 }}>
        {props.fournisseurLibelle}<span className="separator">|</span>{props.fournisseur}
      </div>
      <div style={{ fontWeight: "bold", fontSize: 22 }}>
        {props.date}<span className="separator">|</span>{props.metrage}m
      </div>
      {/* Pour test impression sans connexion  */}
      {/* <div className="column strong">
            <div className="block hard twolines">
              DOUBLO FALCON 60.20 AMERICA
            </div>
            <div className="block">
              KLAUSNER VIA BC ENCADREMENT
            </div>
            <div className="block">
              HETRE ETUVE PREMIER CHOIX
            </div>
            <div className="block">
              gris gorge de pigeon
            </div>
            <div className="block">
              100m
            </div>
            <div className="block hard">
              Q052 - destock
            </div>
            <div className="block">
              23/06/2021
            </div>
          </div> */}
    </div>
  )
}

export default Etiquette
